<template>
    <div class="inactive-profile-banner" :class="{'inactive-for-long':inactiveForLongerTime}">
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-12 inactive-profile-banner-wrapper h-100">

                    <div class="inactive-profile-banner-content h-100" v-if="user">
                        <span>{{ user.username }} {{
                                inactiveForLongerTime ? translate.account.profileIsInactiveLong : translate.account.profileIsInactive
                            }}</span>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        ...mapState(['translate']),
        inactiveForLongerTime() {
            const lastOnline = _.get(this, 'user.contactable');
            return moment().isAfter(moment(lastOnline).add(3, 'months'));
        }
    },
    props: ['user']
}
</script>
